<div class="flowManagement">
  <mat-toolbar class="flowManagementMainToolbar">
    <span class="flowManagement-title">Manage and approve {{sharedService.getEntityType()!=='TEMPLATE'?'Flows':'Templates'}}</span>
    <!-- This fills the remaining space of the current row -->
    <span class="fill-remaining-space"></span>
    <span
      ><button class="flowManagement-close-button" (click)="onClose()">
        <img src='../../../../../assets/svg/close.svg' /></button
    ></span>
  </mat-toolbar>
  <app-approvals class="approvals-component"></app-approvals>
</div>
